import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilderService } from '../../../../core/services/form-builder.service';
import { Subject, takeUntil } from 'rxjs';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  ToastService,
  EIremboFormlyFieldTypes,
} from '@irembo-andela/irembogov3-common';

@Component({
  selector: 'irembogov-settings-toolbar',
  templateUrl: './settings-toolbar.component.html',
  styleUrls: ['./settings-toolbar.component.scss'],
})
export class SettingsToolbarComponent {
  @Input() label? = '';
  @Input() type? = '';
  @Input() field!: FormlyFieldConfig;
  @Output() duplicate = new EventEmitter();
  configureFieldActionSubControl$: Subject<void> = new Subject<void>();

  @Output() fieldConfigActionEvent = new EventEmitter();
  @Output() fieldDuplicateActionEvent = new EventEmitter();

  constructor(
    private formBuilderService: FormBuilderService,
    private toastService: ToastService
  ) {
    this.formBuilderService.configureFieldAction$
      .pipe(takeUntil(this.configureFieldActionSubControl$))
      .subscribe((configuredField: FormlyFieldConfig | null) => {
        if (!(configuredField && this.field)) {
          this.fieldConfigActionEvent.emit(false);
          return;
        }

        this.fieldConfigActionEvent.emit(
          configuredField?.key === this.field.key
        );
      });
  }

  copyFieldKeyToClipBoard() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = <string>this.field?.key;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    try {
      /** try deprecated for compatibility.  */
      document.execCommand('copy');
    } catch (e: any) {
      navigator.clipboard.readText().then((clipText: string) => {
        if (this.field?.key) {
          clipText = this.field.key + clipText;
        }
        return clipText;
      });
    }
    document.body.removeChild(selBox);

    this.toastService.show({
      body: `Field key #${this.field.key} copied to clipboard`,
      type: 'warning',
      delay: 2000,
    });
  }

  setIssueTitleForField(
    label: string | undefined,
    type: string | undefined
  ): void {
    const typeDesc: string = type ? ` [type: ${type}]` : '';
    this.formBuilderService.reviewFlagItemSubject$.next(`${label}${typeDesc}`);
  }

  configureField() {
    this.formBuilderService.configureFieldAction$.next(this.field);
    this.fieldConfigActionEvent.emit(true);
  }

  deleteAction() {
    if (this.field.props) {
      this.formBuilderService.deleteFormField(this.field);
      this.cleanUpLocationWidgetFields();
    }
  }

  duplicateAction() {
    this.formBuilderService.duplicateFormField(this.field);
  }

  private cleanUpLocationWidgetFields() {
    if (this.field.type === EIremboFormlyFieldTypes.customcascadingdropdowns) {
      if (this.field?.parent?.fieldGroup) {
        const relatedLocationWidgetFields =
          this.field?.parent?.fieldGroup.filter(
            field =>
              field.props && field.props['locationWidgetKey'] === this.field.key
          );

        if (relatedLocationWidgetFields.length > 0) {
          relatedLocationWidgetFields.forEach(field => {
            this.formBuilderService.deleteFormField(field);
          });
        }
      }
    }
  }
}
